import Vue from "vue";

import router from "../router/index";
Vue.router = router;

import axios from "axios";
import axiosRetry from 'axios-retry';
import VueAxios from "vue-axios";
import VueAuth from "@websanova/vue-auth";

axiosRetry(axios, {
  retries: 3
});

Vue.use(VueAxios, axios);
Vue.use(VueAuth, {
  auth: require("@websanova/vue-auth/drivers/auth/bearer.js"),
  http: require("@websanova/vue-auth/drivers/http/axios.1.x.js"),
  router: require("@websanova/vue-auth/drivers/router/vue-router.2.x.js"),
  tokenStore: ['cookie', 'localStorage'],
  refreshData: {
    enabled: false
  }
});

Vue.axios.defaults.baseURL = process.env.VUE_APP_API_URL;

/**
 * Element-UI
 */
import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/en";

Vue.use(ElementUI, {
  locale
});

/**
 * Ant Design
 */
import Antd from 'ant-design-vue';
import "ant-design-vue/dist/antd.less";
Vue.use(Antd);

import "@/assets/scss/_main.scss";


import logger from "js-logger";
logger.useDefaults();
Vue.prototype.$log = logger;

import moment from 'moment';
import 'moment/locale/de';
moment.locale('de');
Vue.prototype.$moment = moment;

import VueApexCharts from 'vue-apexcharts';
Vue.component('apexchart', VueApexCharts);